import { useEffect, useState } from 'react'
import { Button, Card } from 'react-bootstrap'
import styled from 'styled-components'
import { BooksitoutServer } from '../../config/BooksitoutServer'
import RouteContainer from '../../common/styles/RouteContainer'
import TipsResponse from '../community/tips/TipsResponse'
import CardTitle from '../../common/styles/CardTitle'
import AdminTipsCard from './AdminTipsCard'
import toast from 'react-hot-toast'
import RowSpacer from '../../common/styles/RowSpacer'
import { useDarkMode } from '../../common/hooks/DarkModeContext'

const AdminRoute = () => {
	const [tipPost, setTipPost] = useState<TipsResponse[]>([])
	useEffect(() => {
		BooksitoutServer.get(`/v1/tips/admin?page=1&size=100`).then(res => setTipPost(res.data))
	}, [])

	const fillBookPublishers = () => {
		if (window.confirm('책 출판사 배치를 강제로 돌릴까요?')) {
			toast.loading(`배치가 돌고 있어요...`)

			BooksitoutServer.post(`/v1/batch/book-publishers/fill`)
				.then(() => toast.success(`책 출판사 배치를 강제로 돌렸어요.`))
				.catch(e => toast.error(`책 출판사 배치 강제 돌리기에 실패했어요. (${e})`))
		}
	}

	const fillBookCategories = () => {
		if (window.confirm('책 카테고리 배치를 강제로 돌릴까요?')) {
			toast.loading(`배치가 돌고 있어요...`)

			BooksitoutServer.post(`/v1/batch/book-category/fill`)
				.then(() => toast.success(`책 카테고리 배치를 강제로 돌렸어요.`))
				.catch(e => toast.error(`책 카테고리 배치 강제 돌리기에 실패했어요. (${e})`))
		}
	}

	const fillBookIsbns = () => {
		if (window.confirm('책 ISBN 배치를 강제로 돌릴까요?')) {
			toast.loading(`배치가 돌고 있어요...`)

			BooksitoutServer.post(`/v1/batch/book-isbn/fill`)
				.then(() => toast.success(`책 ISBN 배치를 강제로 돌렸어요.`))
				.catch(e => toast.error(`책 ISBN 배치 강제 돌리기에 실패했어요. (${e})`))
		}
	}

	const cacheBestSellers = () => {
		if (window.confirm('베스트 셀러 배치를 강제로 돌릴까요?')) {
			toast.loading(`배치가 돌고 있어요...`)

			BooksitoutServer.post(`/v1/batch/rankings/best-sellers/cache`)
				.then(() => toast.success(`베스트 셀러 배치를 강제로 돌렸어요.`))
				.catch(e => toast.error(`베스트 셀러 배치 강제 돌리기에 실패했어요. (${e})`))
		}
	}

	const cacheUserRankings = () => {
		if (window.confirm('유저 랭킹 배치를 강제로 돌릴까요?')) {
			toast.loading(`배치가 돌고 있어요...`)

			BooksitoutServer.post(`/v1/batch/rankings/users/cache`)
				.then(() => toast.success(`유저 랭킹 배치를 강제로 돌렸어요.`))
				.catch(e => toast.error(`유저 랭킹 배치 강제 돌리기에 실패했어요. (${e})`))
		}
	}

	const updateLibraryData = () => {
		if (window.confirm('도서관 배치를 강제로 돌릴까요?')) {
			toast.loading(`배치가 돌고 있어요...`)

			BooksitoutServer.post(`/v1/batch/libraries/update`)
				.then(() => toast.success(`도서관 배치를 강제로 돌렸어요.`))
				.catch(e => toast.error(`도서관 배치 강제 돌리기에 실패했어요. (${e})`))
		}
	}

	const webCrawlingCheck = () => {
		if (window.confirm('웹 크롤링 확인 배치를 강제로 돌릴까요?')) {
			toast.loading(`배치가 돌고 있어요...`)

			BooksitoutServer.post(`/v1/batch/web-crawling/check`)
				.then(() => toast.success(`웹 크롤링 확인 배치를 강제로 돌렸어요.`))
				.catch(e => toast.error(`웹 크롤링 확인 배치 강제 돌리기에 실패했어요. (${e})`))
		}
	}

	const cacheHolidays = () => {
		if (window.confirm('공휴일 캐시 배치를 강제로 돌릴까요?')) {
			toast.loading(`배치가 돌고 있어요...`)

			BooksitoutServer.post(`/v1/batch/holidays/cache`)
				.then(() => toast.success(`공휴일 캐시 배치를 강제로 돌렸어요.`))
				.catch(e => toast.error(`공휴일 캐시 배치 강제 돌리기에 실패했어요. (${e})`))
		}
	}

	const backfillBookIsbnKeywords = () => {
		const limitInput = window.prompt('책 연관 키워드 배치를 몇 권 돌릴까요? (베스트셀러부터, 최대 1000)', '100')
		if (limitInput == null) return

		const limit = Number(limitInput)
		if (!Number.isInteger(limit) || limit < 1 || limit > 1000) {
			toast.error('1에서 1000 사이 숫자를 입력해 주세요.')
			return
		}

		const toastId = toast.loading(`배치가 돌고 있어요...`)

		BooksitoutServer.post<BookIsbnKeywordBackfillResponse>(`/v1/batch/book-isbn/keywords/backfill`, null, { params: { limit } })
			.then(res => {
				const { requested, bestSellers, withKeywords, empty, failed } = res.data
				toast.success(`책 연관 키워드 배치를 돌렸어요. (${requested}권 중 베스트셀러 ${bestSellers}권 · 키워드 ${withKeywords}권 · 없음 ${empty}권 · 실패 ${failed}권)`, { id: toastId })
			})
			.catch(e => toast.error(`책 연관 키워드 배치 강제 돌리기에 실패했어요. (${e})`, { id: toastId }))
	}

	const { setIsAdmin } = useDarkMode()
	const handleDarkMode = () => {
		localStorage.setItem('isAdmin', 'true')
		setIsAdmin(true)
	}

	return (
		<RouteContainer>
			<CardTips>
				<Card.Body style={{ backgroundColor: 'var(--sub-bg-color)' }}>
					<CardTitle icon={undefined} title={'관리자용'} url={''} />

					<div className={'row'}>
						<div className={'col-6 col-md-4'}>
							<Button variant={'book'} className={'w-100'} onClick={fillBookPublishers}>
								책 출판사 배치 돌리기
							</Button>
							<RowSpacer />
						</div>

						<div className={'col-6 col-md-4'}>
							<Button variant={'book'} className={'w-100'} onClick={fillBookCategories}>
								책 카테고리 배치 돌리기
							</Button>
							<RowSpacer />
						</div>

						<div className={'col-6 col-md-4'}>
							<Button variant={'book'} className={'w-100'} onClick={fillBookIsbns}>
								책 ISBN 배치 돌리기
							</Button>
							<RowSpacer />
						</div>

						<div className={'col-6 col-md-4'}>
							<Button variant={'book'} className={'w-100'} onClick={cacheBestSellers}>
								베스트 셀러 배치 돌리기
							</Button>
							<RowSpacer />
						</div>

						<div className={'col-6 col-md-4'}>
							<Button variant={'book'} className={'w-100'} onClick={cacheUserRankings}>
								유저 랭킹 배치 돌리기
							</Button>
							<RowSpacer />
						</div>

						<div className={'col-6 col-md-4'}>
							<Button variant={'book'} className={'w-100'} onClick={updateLibraryData}>
								도서관 배치 돌리기
							</Button>
							<RowSpacer />
						</div>

						<div className={'col-6 col-md-4'}>
							<Button variant={'book'} className={'w-100'} onClick={webCrawlingCheck}>
								웹 크롤링 확인 배치 돌리기
							</Button>
							<RowSpacer />
						</div>

						<div className={'col-6 col-md-4'}>
							<Button variant={'book'} className={'w-100'} onClick={cacheHolidays}>
								공휴일 캐시 배치 돌리기
							</Button>
							<RowSpacer />
						</div>

						<div className={'col-6 col-md-4'}>
							<Button variant={'book'} className={'w-100'} onClick={backfillBookIsbnKeywords}>
								책 연관 키워드 배치 돌리기
							</Button>
							<RowSpacer />
						</div>

						<div className={'col-6 col-md-4'}>
							<Button variant={'book'} className={'w-100'} onClick={handleDarkMode}>
								다크모드 사용해보기
							</Button>
							<RowSpacer />
						</div>
					</div>

					<div className="row">{tipPost == null ? <></> : tipPost.map(tip => <AdminTipsCard key={tip.id} tip={tip} isAdmin={true} isPublic={tip.isPublic} />)}</div>
				</Card.Body>
			</CardTips>
		</RouteContainer>
	)
}

// booksitout-server BookIsbnKeywordService.BackfillResult
interface BookIsbnKeywordBackfillResponse {
	requested: number
	bestSellers: number
	withKeywords: number
	empty: number
	failed: number
}

const CardTips = styled(Card)`
	min-height: 1000px;
`

export default AdminRoute
